import Vue from "vue";
import ModelRouter from "vue-modal-router";

Vue.use(ModelRouter, {
  delay: 500,
  model: "show"
});

export default new ModelRouter({});
